"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRAY_HANDLE_ZINDEX = exports.VENEER_FIXED_ZINDEX = exports.HEADER_FIXED_ZINDEX = exports.ASIDE_FIXED_ZINDEX = exports.MAIN_FIXED_ZINDEX = exports.BG_FIXED_ZINDEX = exports.HTMLROOT_FIXED_ZINDEX = void 0;
exports.HTMLROOT_FIXED_ZINDEX = 0;
exports.BG_FIXED_ZINDEX = 1;
exports.MAIN_FIXED_ZINDEX = 2;
exports.ASIDE_FIXED_ZINDEX = 3;
exports.HEADER_FIXED_ZINDEX = 4;
exports.VENEER_FIXED_ZINDEX = 5;
exports.TRAY_HANDLE_ZINDEX = 5;
//# sourceMappingURL=zIndex.js.map